import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"elevation":_vm.elevation}},[(_vm.hasNote)?_c('span',{staticClass:"square"}):_vm._e(),_vm._l((_vm.formattedBody),function(text,index){return _c('p',{key:index,domProps:{"innerHTML":_vm._s(text)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }